import { InjectionToken } from '@angular/core';
import { IOrdersSettings } from '@epicuro-next/models/order-book';

export const ORDERS_SETTINGS_TOKEN = new InjectionToken<IOrdersSettings>(
  'Orders Settings',
);
